import { useQuery } from "@tanstack/react-query";
import websiteConfigurationService from "../../services/websiteConfiguration.service";

// 0015: the SINGLE fetch of website configurations (logo, banners, theme). NOT auth-gated — the
// logo renders for anonymous visitors. React Query dedups the header + footer logo consumers (and
// StrictMode) to ONE network call. staleTime 5 min — config is near-static.
const useWebsiteConfigurationQuery = () =>
  useQuery({
    queryKey: ["websiteConfiguration"],
    queryFn: () => websiteConfigurationService.getAllConfigurations().then((r) => r.data.payload),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

export default useWebsiteConfigurationQuery;
